import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { BroadcastService } from '../../../services/broadcast.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from '../../../services/helpers.service';
import { PartnerService } from '../../../services/partner.service';
import { ThirdPartyService } from '../../../services/thirdparty.service';
import { AppConfig } from '../../../app.config';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-edit-third-party',
  templateUrl: './add-edit-third-party.component.html',
  styleUrls: ['./add-edit-third-party.component.scss'],
})
export class AddEditThirdPartyComponent implements OnInit {
  @Output() closeSidePanel = new EventEmitter();
  @Input() messageService;
  @Input() selectedThirdParty;
  @Input() editing;
  @Input() combinedServicesUsed;
  //hier moet ons serviceTypes van list af hide of weg vat wat klaar in die combinedServicesUsed list is

  public partnerID: string = '';

  public statusList: any = [];
  public selectedStatusListValues: {
    statusID: any;
    customer: boolean;
    thirdParty: boolean;
  }[] = [];

  public serviceTypes: any = [];

  public name: string = '';

  public busy = false;
  public saveLoading = false;
  public deleteLoading = false;

  public thirdPartyForm: FormGroup;

  public editThirdParty: any;

  public uploadingLogoImage: boolean = false;
  public imageMediaData: any;
  public imagePreview: any = null;
  public imageRemove: any = false;

  constructor(
    private fb: FormBuilder,
    public appConfig: AppConfig,
    public partnerService: PartnerService,
    public thirdPartyService: ThirdPartyService,
    public translate: TranslateService,
    public helpersService: HelpersService,
  ) {}

  ngOnInit() {
    this.partnerID = this.helpersService.getPartnerId();

    this.editThirdParty = this.selectedThirdParty;

    this.statusList = this.appConfig.getStatusList().sort((a, b) => {
      if (a.order < b.order) return -1;
      else if (a.order > b.order) return 1;
      else return 0;
    });

    const existingStatusValues =
      this.editThirdParty.selectedStatusNotifyValues || [];

    this.selectedStatusListValues = this.statusList.map((status) => {
      const existingStatusIndex = existingStatusValues.findIndex(
        (x) => x.statusID === status.key,
      );
      const customer = existingStatusValues[existingStatusIndex]
        ? existingStatusValues[existingStatusIndex].customer
        : true;
      const thirdParty = existingStatusValues[existingStatusIndex]
        ? existingStatusValues[existingStatusIndex].thirdParty
        : true;

      return {
        statusID: status.key,
        customer: customer,
        thirdParty: thirdParty,
      };
    });

    //this.getServiceTypes();
    this.setupValidation();

    console.log(this.editThirdParty.selectedServiceTypes);
  }

  imageUploader(event) {
    if (!event.target.files[0]) {
      // No file was selected
      return;
    }

    this.uploadingLogoImage = true;
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.imagePreview = reader.result.toString();

      this.imageMediaData = {
        ImageData: reader.result.toString().replace(/^data:(.*;base64,)?/, ''),
        ImageDataExt: this.getFileExtension(reader.result),
      };
      console.log(this.imageMediaData);
      this.imageRemove = false;

      this.uploadingLogoImage = false;
    };
  }

  removeImageUrl() {
    this.uploadingLogoImage = true;

    this.imagePreview = null;
    this.imageMediaData = null;
    this.imageRemove = true;

    this.uploadingLogoImage = false;
  }

  getFileExtension(file) {
    const mimeType = file.match(/^data:(.*);/)[1];
    const extensions = {
      'image/jpeg': 'jpg',
      'image/png': 'png',
      // Add more MIME types and their corresponding extensions here
    };

    return extensions[mimeType] || 'unknown';
  }

  getServiceTypes() {
    this.serviceTypes = [];
    this.partnerService
      .getPartnerServiceTypesFull(this.partnerID)
      .subscribe((serviceTypes) => {
        var GroupName = '';
        serviceTypes
          .filter((serviceType) => {
            return serviceType.IsActive;
          })
          .sort((x, y) => {
            return x.GroupOrder - y.GroupOrder || x.GroupName - y.GroupName;
          })
          .map((serviceType) => {
            console.log(serviceType);
            serviceType.GroupName = serviceType.GroupName
              ? serviceType.GroupName
              : this.translate.instant('general.not_grouped');
            if (serviceType.GroupName !== GroupName) {
              GroupName = serviceType.GroupName;
              this.serviceTypes.push({
                label: serviceType.GroupName,
                value: -1,
                disabled: true,
                search: '',
                reverseSearch: '',
                hasPartnerServiceType: '',
                thirdPartyName: '',
              });
            }
            var words = serviceType.ServiceTypeDescription.split(' ');
            var reverseSearch = [];
            if (words) {
              words.forEach((word) => {
                reverseSearch.unshift(word);
              });
            }

            // Check if the service type is in thirdParty.selectedServiceTypes
            var isSelected =
              this.editThirdParty.selectedServiceTypes &&
              this.editThirdParty.selectedServiceTypes.includes(serviceType.ID);
            var isAlreadyUsed = false; // this.combinedServicesUsed && this.combinedServicesUsed.includes(serviceType.ID);

            this.serviceTypes.push({
              //label: serviceType.ServiceTypeDescription + (isSelected == true ? '' : isAlreadyUsed == true ? ' (already used)' : ''),
              label: serviceType.ServiceTypeDescription,
              value: serviceType.ID,
              disabled: isSelected == true ? false : isAlreadyUsed,
              search: serviceType.ServiceTypeDescription,
              reverseSearch: reverseSearch.join(' '),
              hasPartnerServiceType: serviceType.HasPartnerServiceType,
              thirdPartyName: serviceType.LinkedToThirdPartyName,
            });
          });
        // console.log(this.editThirdParty.selectedServiceTypes);
        // console.log(this.combinedServicesUsed);
        // console.log(this.serviceTypes);

        this.thirdPartyForm
          .get('selectedServiceTypes')
          .setValue(this.editThirdParty.selectedServiceTypes || []);
      });
  }

  setupValidation() {
    this.thirdPartyForm = this.fb.group({
      name: new FormControl(
        this.editThirdParty.name || '',
        Validators.required,
      ),
      contactName: new FormControl(
        this.editThirdParty.contactName || '',
        Validators.required,
      ),
      phoneNumber: new FormControl(this.editThirdParty.phoneNumber || ''),
      address: new FormControl(this.editThirdParty.address || ''),

      // //Service Types Elements
      // selectedServiceTypes: new FormControl(
      //   this.editThirdParty.selectedServiceTypes || []
      // ),
      // responsibleForPayment:new FormControl(
      //   this.editThirdParty.responsibleForPayment || false
      // ),

      //Notify Elements
      notifyEmails: new FormControl(this.editThirdParty.notifyEmails || ''),
    });

    // todo(dcorbett) removed    [this.emailListValidator]

    if (this.editThirdParty.imageDisplay) {
      this.imagePreview = this.editThirdParty.imageDisplay;
    }
  }

  emailListValidator(control: FormControl): { [key: string]: any } | null {
    const emails = control.value.split(',').map((email) => email.trim());
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;

    for (const email of emails) {
      if (!emailRegex.test(email)) {
        return { invalidEmail: true };
      }
    }

    return null;
  }

  checkSave() {
    if (!this.thirdPartyForm.valid) {
      // Handle form validation errors
      console.log('Form is invalid');

      for (const controlName in this.thirdPartyForm.controls) {
        if (this.thirdPartyForm.controls.hasOwnProperty(controlName)) {
          const control = this.thirdPartyForm.get(controlName);

          if (control.invalid) {
            console.log(`Control "${controlName}" is invalid.`);
            console.log('Validation errors:', control.errors);
          }
        }
      }
      return;
    }

    if (this.editing) {
      this.updateThirdParty();
    } else {
      this.addThirdParty();
    }
  }

  addThirdParty() {
    var data = {
      ...this.thirdPartyForm.value,
      selectedStatusNotifyValues: this.selectedStatusListValues,
      image: this.imageMediaData,
    };
    console.log(data);

    this.saveLoading = true;
    this.busy = true;

    this.thirdPartyService.createThirdParty(this.partnerID, data).subscribe(
      (thirdParty) => {
        this.messageService.add({
          key: 'bottom-center',
          detail: this.translate.instant('bikeshop.thirdparty.manage.added'),
        });
        this.busy = false;
        this.saveLoading = false;
        this.closeSidePanel.emit(thirdParty);
      },
      (err) => {
        this.busy = false;
        this.saveLoading = false;
      },
    );
  }

  updateThirdParty() {
    console.log('update');
    var data = {
      id: this.selectedThirdParty.id,
      ...this.thirdPartyForm.value,
      selectedStatusNotifyValues: this.selectedStatusListValues,
      imageRemove: this.imageRemove,
      image: this.imageMediaData,
    };
    console.log(data);

    this.saveLoading = true;
    this.busy = true;

    this.thirdPartyService
      .updateThirdParty(this.partnerID, this.selectedThirdParty.id, data)
      .subscribe(
        (thirdParty) => {
          this.messageService.add({
            key: 'bottom-center',
            detail: this.translate.instant(
              'bikeshop.thirdparty.manage.updated',
            ),
          });
          this.busy = false;
          this.saveLoading = false;
          this.closeSidePanel.emit(thirdParty);
        },
        (err) => {
          this.busy = false;
          this.saveLoading = false;
        },
      );
  }

  deleteThirdParty() {
    this.busy = true;
    this.deleteLoading = true;

    this.thirdPartyService
      .deleteThirdParty(this.partnerID, this.selectedThirdParty.id)
      .subscribe(
        (thirdParty) => {
          this.busy = false;
          this.deleteLoading = false;
          this.closeSidePanel.emit({
            status: 'deleted',
            id: this.selectedThirdParty.id,
          });
        },
        (err) => {
          this.busy = false;
          this.deleteLoading = false;
        },
      );
  }
}
